import React from 'react';
import { CATEGORIES } from '@/data/products';

export default function CategoryChips({ active, onSelect, counts }) {
  return (
    <div
      className="flex gap-2 overflow-x-auto pb-2 mb-8 scrollbar-hide"
      role="group"
      aria-label="Filter products by category"
    >
      {CATEGORIES.map(cat => {
        const count = cat === 'All' ? counts.total : (counts[cat] ?? 0);
        const isActive = active === cat;
        return (
          <button
            key={cat}
            onClick={() => onSelect(cat)}
            aria-pressed={isActive}
            className={`shrink-0 inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-[2px] border font-sans text-[0.6875rem] font-medium tracking-[0.08em] uppercase transition-colors duration-150 whitespace-nowrap focus-visible:outline focus-visible:outline-2 focus-visible:outline-gold-edge focus-visible:outline-offset-1 ${
              isActive
                ? 'bg-ink-deep border-ink-deep text-parchment'
                : 'bg-transparent border-border-warm text-ink-muted hover:bg-parchment hover:border-ink-body hover:text-ink-body'
            }`}
          >
            {cat}
            <span className={`text-[0.625rem] tabular-nums ${isActive ? 'text-parchment/60' : 'text-ink-muted/60'}`}>
              {count}
            </span>
          </button>
        );
      })}
    </div>
  );
}
